// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2aa4H","content":"Consent_content__3Quga","footer":"Consent_footer__wgaQF"};